import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const INTERESTS_QUERY_KEY = 'interests';

// Custom hook for fetching interests
export const useInterests = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: [INTERESTS_QUERY_KEY, page, limit],
    queryFn: () => apiClient.interests.getAll(page, limit),
    keepPreviousData: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

// Custom hook for creating an interest
export const useCreateInterest = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (interestData) => apiClient.interests.create(interestData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INTERESTS_QUERY_KEY] });
    },
  });
};

// Custom hook for updating an interest
export const useUpdateInterest = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, interestData }) => apiClient.interests.update(id, interestData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INTERESTS_QUERY_KEY] });
    },
  });
};

// Custom hook for deleting an interest
export const useDeleteInterest = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => apiClient.interests.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INTERESTS_QUERY_KEY] });
    },
  });
};

// Custom hook for getting a single interest
export const useInterest = (id) => {
  return useQuery({
    queryKey: [INTERESTS_QUERY_KEY, id],
    queryFn: () => apiClient.interests.getById(id),
    enabled: !!id,
  });
}; 